import axios from 'axios'
import commonUrl from '../common/js/commonUrl.js'
import qs from 'qs'
import {loadVillageId, loadUserId} from '../common/js/cache'

// 判断是否是管理员和小区业主
export function getMangers() {
  const url = `${commonUrl.apihost}/index.php/home/index/role`
  const data = {
    user_id: loadUserId(),
    areas_id: loadVillageId()
  }
  return axios({
    method: 'POST',
    url: url,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((err) => {
    return Promise.reject(err)
  })
}

// 单独判断是否是管理员（之前用来判断扫码送票的工作人员）
export function getAdmin() {
  const url = `${commonUrl.apihost}/index.php/home/index/voteManager`
  const data = {
    user_id: loadUserId()
  }
  return axios({
    method: 'POST',
    url: url,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((err) => {
    return Promise.reject(err)
  })
}

// 员工入口
export function getEnter () {
  const url = `${commonUrl.apihost}index.php/home/index/areaManager`
  const data = {
    user_id: loadUserId()
  }
  return axios({
    method: 'POST',
    url: url,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((err) => {
    return Promise.reject(err)
  })
}



// WEBPACK FOOTER //
// ./src/api/management.js